import React from 'react';
import { EditAltIcon } from 'cokitchen-icons';
import { AddonItemProps } from './types';

import Select from 'components/base/select';

const AddonItem = ({
  addon,
  isEdit,
  onEditClick,
  updateAddon,
  disabled,
  baseMeals
}: AddonItemProps) => {
  return (
    <div className='shadow py-4 px-3 rounded relative'>
      <div className='flex space-y-2 flex-col'>
        {isEdit ? (
          <>
            <input
              value={addon.name}
              placeholder='Enter addon name'
              disabled={!isEdit}
              onChange={(e) => updateAddon(e, 'name')}
              className={`w-auto  text-xs  h-[30px] border outline-none border-gray-13 p-1 rounded-md ${
                isEdit ? 'caret-current' : 'caret-transparent '
              } `}
            />
            <div>
              <p className='text-sm'>Select Base meal</p>
              <Select
                hasSearch
                //loading={loading}
                value={addon.addon_meal_id ?? ''}
                options={baseMeals.map((item) => {
                  return { value: item.id, text: item.name };
                })}
                placeholder='Select base meal'
                onChange={(v) => updateAddon(v, 'addon_meal_id')}
              />
            </div>
            <input
              value={addon.quantity}
              placeholder='Enter addon quantity'
              disabled={!isEdit}
              onChange={(e) => updateAddon(e, 'quantity')}
              className={`w-auto  text-xs  h-[30px] border outline-none border-gray-13 p-1 rounded-md ${
                isEdit ? 'caret-current' : 'caret-transparent '
              } `}
            />
          </>
        ) : (
          <>
            <p className='text-xs font-semibold capitalize'>
              <span className='font-medium'>Base meal: </span>
              {baseMeals.find((meal) => meal.id === addon?.addon_meal_id)?.name}
            </p>
            <p className='text-xs text-gray-8'>
              <span className='font-medium'>Name: </span>
              {addon?.name}
            </p>

            <p className='text-xs text-gray-8'>
              {' '}
              <span className='font-medium'>Quantity: </span> {addon?.quantity}
            </p>
          </>
        )}
      </div>

      {!disabled && (
        <EditAltIcon
          onClick={onEditClick}
          className={`absolute top-[-10px] right-[2px] cursor-pointer rounded-md border w-5 h-5 p-[2.5px] transition-all  bg-white ${
            isEdit ? 'border-blue-1 text-blue-5 ' : 'border-[#EAEBEB] text-gray-4 '
          }`}
        />
      )}

      {addon.hasError && (
        <div className='absolute top-[-3px] right-[26px] h-2 w-2  bg-red-5 rounded-full ml-1' />
      )}
    </div>
  );
};

export default AddonItem;
